import { useEffect, useState } from 'react';
import {
  applyTemplate,
  getCatalog,
  getTemplates,
  type CatalogItem,
  type Template,
} from './deals-api';
import { DealModal } from './DealModal';
import { NewDealModal } from './NewDealModal';
import { mln } from './format';
import { useUser } from './user-context';
import { invalidate } from './useData';

// Конструктор: каталог блоками + шаблоны комплексов. Шаблон создаёт новую
// сделку и сразу открывает её карточку с собранным составом и авто-суммой.
export function CatalogScreen() {
  const user = useUser();
  const [catalog, setCatalog] = useState<CatalogItem[]>([]);
  const [templates, setTemplates] = useState<Template[]>([]);
  const [openId, setOpenId] = useState<number | null>(null);
  const [buildFor, setBuildFor] = useState<Template | null>(null);
  const canEdit = user.screens.includes('deals');

  useEffect(() => {
    getCatalog().then((r) => setCatalog(r.catalog));
    getTemplates().then((r) => setTemplates(r.templates));
  }, []);

  // Сделка создана в модалке → накатываем выбранный шаблон и открываем карточку.
  async function onBuilt(id: number) {
    const t = buildFor;
    setBuildFor(null);
    if (t) await applyTemplate(id, t.id).catch(() => {});
    invalidate('deals');
    setOpenId(id);
  }

  const byCat = catalog.reduce<Record<string, CatalogItem[]>>((acc, c) => {
    (acc[c.cat] ??= []).push(c);
    return acc;
  }, {});

  return (
    <div className="scr">
      <div className="scr-head">
        <h2>Конструктор заказа</h2>
        <span className="muted">каталог и шаблоны комплексов</span>
      </div>

      <div className="section-t">Шаблоны комплексов «под ключ»</div>
      <div className="grid-cards">
        {templates.map((t) => (
          <div className="catcard" key={t.id}>
            <div className="cn">{t.name}</div>
            <div className="rmeta" style={{ marginBottom: 10 }}>
              {t.descr}
            </div>
            {canEdit && (
              <button className="btn sm" onClick={() => setBuildFor(t)}>
                Собрать сделку →
              </button>
            )}
          </div>
        ))}
      </div>

      {Object.entries(byCat).map(([cat, items]) => (
        <div key={cat}>
          <div className="section-t">{cat}</div>
          <div className="grid-cards">
            {items.map((c) => (
              <div className="catcard" key={c.id}>
                <div className="ci">{c.ico}</div>
                <div className="cn">{c.name}</div>
                <div className="cp">{mln(c.price)} ₸</div>
                <div className="rmeta">за {c.unit}</div>
              </div>
            ))}
          </div>
        </div>
      ))}

      {buildFor && (
        <NewDealModal
          title="Сделка из шаблона"
          subtitle={`«${buildFor.name}» · состав соберётся автоматически`}
          onClose={() => setBuildFor(null)}
          onCreated={onBuilt}
        />
      )}
      {openId != null && (
        <DealModal
          dealId={openId}
          screens={user.screens}
          onClose={() => setOpenId(null)}
          onChanged={() => invalidate('deals')}
        />
      )}
    </div>
  );
}
